import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';

import {ServiceManagerHttpService} from 'libs/shared/http/src/lib/services/http/http.service';
import {ServiceResponse} from 'libs/shared/model/src/lib/models/service-response.model';
import {ServiceResult} from 'libs/shared/model/src/lib/models/service-result';
import {isoToDateTime} from 'libs/shared/util/src/lib/_helpers/date-formatter';
import {NotificationStatusEnum} from '../enums/notification-types.enum';
import {Notification} from '../models/notification.model';
import {NotificationFilter, NotificationResponse} from '../models/request-response-notification.models';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    constructor(private httpService: ServiceManagerHttpService) {}

    getFacultyNotifications(filter: NotificationFilter): Observable<NotificationResponse> {
        const path = '/notification/GetNotifications';

        return this.httpService.post<NotificationResponse>(path, filter).pipe(
            map((response) => ({
                ...response,
                Notifications: response?.Notifications?.map((x) => ({
                    ...x,
                    Notification: {
                        ...x.Notification,
                        AvailableDate: isoToDateTime(x.Notification.AvailableDate),
                        CreatedAt: isoToDateTime(x.Notification.CreatedAt)
                    }
                }))
            }))
        );
    }

    /// <summary>
    /// Change status for a single notification
    /// </summary>
    changeNotificationStatus(notificationId: number, newStatus: NotificationStatusEnum): Observable<ServiceResponse> {
        const path = '/notification/ChangeNotificationStatus';
        const body = {
            NotificationIds: [notificationId],
            NewStatus: newStatus
        };

        return this.httpService.post<ServiceResponse>(path, body);
    }

    //// <summary>
    /// Change status for multiple notifications
    /// </summary>
    changeNotificationsStatus(
        notificationIds: number[],
        newStatus: NotificationStatusEnum
    ): Observable<ServiceResponse> {
        const path = '/notification/ChangeNotificationStatus';
        const body = {
            NotificationIds: notificationIds,
            NewStatus: newStatus
        };

        return this.httpService.post<ServiceResponse>(path, body);
    }

    getMemberNotification(): Observable<ServiceResponse & {Notify: boolean}> {
        const url = `/notification/member-notification`;

        const result = this.httpService.get<ServiceResult<NotificationService['getMemberNotification']>>(url);

        return result;
    }

    deleteMemberNotification(): Observable<ServiceResponse> {
        const url = `/notification/member-notification`;

        const result = this.httpService.delete<ServiceResult<NotificationService['deleteMemberNotification']>>(
            url,
            null
        );

        return result;
    }

    getMemberInboxNotifications(externalSubscriptionId: string): Observable<GetMemberInboxNotificationsResponse> {
        const url = `/notification/member-inbox-notifications/${externalSubscriptionId}`;

        const result = this.httpService.get<GetMemberInboxNotificationsResponse>(url);

        return result;
    }

    memberMarkNotificationAsRead(notificationId: number): Observable<ServiceResponse> {
        const url = `/notification/member-inbox/${notificationId}/mark-as-read`;

        const result = this.httpService.post<ServiceResponse>(url, {});

        return result;
    }
}

export interface GetMemberInboxNotificationsResponse {
    MemberNotifications: Notification[];
}
